export default class TextOnlyStyleTypeUtil {
    /**
     * 
     * @returns 
     */
    containsPoint(): boolean {
        // TextOnly so cannot contain a point
        return false;
    }
}